import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { searchPosts } from '../../data/blogData';
import './SearchResults.css';

function SearchResults() {
  const [searchParams] = useSearchParams();
  const query = searchParams.get('q') || '';
  const results = searchPosts(query);

  return (
    <section className="search-results-wrapper">
      <div className="container">
        <h2 className="results-heading">Search Results</h2>
        <p className="results-count">
          {results.length > 0
            ? `${results.length} result${results.length > 1 ? 's' : ''} for "${query}"`
            : `Showing results for "${query}"`}
        </p>

        {results.length === 0 ? (
          <div className="no-results">
            <i className="bi bi-search"></i>
            <h4>No results found</h4>
            <p>
              We couldn't find any posts matching <strong>"{query}"</strong>.
              Try a different keyword.
            </p>
          </div>
        ) : (
          <div className="row g-4">
            {results.map((post) => (
              <div className="col-12 col-md-6 col-lg-4" key={post.id}>
                <div className="card h-100 border-0">
                  <img
                    src={post.image}
                    className="card-img-top rounded-0"
                    alt={post.title}
                  />
                  <div className="card-body px-0">
                    <Link to={`/blog/${post.slug}`} className="text-decoration-none">
                      <h5 className="result-card-title mb-2">{post.title}</h5>
                    </Link>
                    <p className="result-excerpt">{post.excerpt}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}

export default SearchResults;
